import React, { Component, Fragment } from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Input,
  Card,
  CardBody,
  ModalFooter,
} from 'reactstrap';
import { connect } from 'react-redux';
import IntlMessages from '../../../../helpers/IntlMessages';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import Visitor from './components/visitor';
import Chat from './components/Chat';
import { CardTitle } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import noactivechats from '../../../../assets/no_active_chats.png';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import country from '../../../../data/country';
import topic from '../../../../data/topic';
import { Client as ConversationsClient } from '@twilio/conversations';
import {
  gAPI_Conversations_list,
  postAPI_Create_Ticket,
  gAPI_Users_By_Id,
  gAPI_TicketsRecording_id,
  gAPI_QuickReplies,
  putAPI_ConversationsStatus_By_Id,
  postAPI_TrackEvent,
  putAPI_ConversationsTwilioStart,
  putAPI_ConversationsFacebookTransfer,
  gAPI_Conversations_By_Id,
  putAPI_UpdateAgentStatus_By_Id,
  gAPI_Conversations_Activelist,
  putAPI_UpdateChatStatus_By_Id,
  gAPI_QuickReplies_listByGroup,
} from '../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
  AxiosPublicAPI,
} from '../../../../helpers/AxiosAPI';
import { fetchServiceRequest } from '../../../../redux/service/actions';
import {
  getChatList,
  getChatListSearch,
  getChat,
  getPropertyList,
  createTicket,
  BotBlink,
  AgentBlink,
} from '../../../../redux/actions';
import ChatMessage from '../../../../components/chats/ChatMessage';
import { injectIntl } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';
import {
  reactSelectOption,
  reactSelectOptionDiffrentPro,
} from '../../../../helpers/Utils';
import Archives from './components/Archives';
import Conversations from './components/Conversations';
import 'moment-timezone';
import { HubConnectionBuilder } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import Axios from 'axios';
import store from '../../../../redux/store'; // import redux store
import Validation from '../../../../components/Validation';

const TWILIO_URL = process.env.REACT_APP_CHAT_API + '/twilio';
const TWILIOCHANNEL_URL = process.env.REACT_APP_CHAT_API + '/twiliochannels';
const TWILIO_TOKEN_GEN_URL = process.env.REACT_APP_CHAT_API + '/twilio-token';
const STOPFB_URL = process.env.REACT_APP_CHAT_API + '/stopfb';
const RESUMEFB_URL = process.env.REACT_APP_CHAT_API + '/resumefb';
const TWILIO_END_CONVERSATION =
  process.env.REACT_APP_CHAT_API + '/endTwilioConversation';
const TWILIO_END_CHANNELCONVERSATION =
  process.env.REACT_APP_CHAT_API + '/endTwilioChannel';
const TicketTypeOptions = [
  { value: 'Booking & Rates Enquiry', label: 'Booking & Rates Enquiry' },
  { value: 'Change/Cancel Booking', label: 'Change/Cancel Booking' },
  { value: 'About Amenities', label: 'About Amenities' },
  { value: 'Special Request', label: 'Special Request' },
  { value: 'Other Query', label: 'Other Query' },
];
class OngoingConversationsPage extends Component {
  constructor(props) {
    super(props);
    this._scrollBarRef1 = React.createRef();
    this.myChatRef = React.createRef();

    this.state = {
      startDate: moment().subtract(2, 'days'),
      endDate: moment(),
      hotel: {},
      embeddedDate: moment(),
      items: 500,
      code: {},
      open: false,
      msg: [],
      topicName: {},
      offset: 0,
      loading: false,
      data: [],
      activeIndex: -1,
      ticketTitle: '',
      ticketComments: '',
      ticketType: null,
      ticketPriority: null,
      popupProperty: null,
      isVisibleTicketBtn: false,
      selectedChat: null,
      isLoading: false,
      isLoadmore: true,
      showLoadMoreBtn: false,
      isFiltering: true,
      showTwilioConversationList: false,
      twilioToken: '',
      transfertobot: false,
      transfertomesseger: false,
      facebookSenderName: '',
      recordingurl: '',
      transcript: '',
      channel: 'All',
      quickReplyTemplates: [],
      statusmodal: false,
      cstatus: 'Opened',
      filterstatus: 'Opened',
      googleSenderName: '',
      accessToken: '',
      twilioConversations: [],
      twilioChatId: '',
      newTwilioChatId: '',
      intervalId: null,
      forceRefresh: false,
      twilioLoaded: true,
      chatConnection: null,
      chatInvitations: [],
      agentConversations: [],
      waitingConversations: [],
      chatBotConversations: [],
      activeChat: '',
      agentAccess: undefined,
      chatReplyTemplates: [],
      isMasked:
        sessionStorage.getItem('lock') === null
          ? 'false'
          : sessionStorage.getItem('lock'),
      // data: this.props.getChatList({pid:'0b999af2-e798-49ae-bac6-b00559fde7d0',items:10,offset:0})
    };
    this.audio = new Audio(
      'https://assets.bookmebob.com/images/chat_notification.mp3'
    );
  }
  componentDidUpdate(prevProps) {
    if (prevProps.properties !== this.props.properties) {
      const permissionProperties = this.props.properties.map((z) => z.id);
      const data = {
        groupId: getGroupID(),
        properties: permissionProperties,
        agent: getUserID(),
      };
      //  console.log(data);
      AxiosAPI({
        method: 'post',
        url: `${gAPI_Conversations_Activelist}`,
        data: data,
      }).then(
        (res) => {
          //  console.log(res.data);
          this.setState((state) => ({
            agentConversations: res.data.myConversations,
            waitingConversations: res.data.queueConversations,
            chatBotConversations: res.data.botConversations,
            isLoading: false,
          }));
          if (res.data.myConversations.length > 0) {
            this.setState({
              activeChat: res.data.myConversations[0].conversationId,
              isVisibleTicketBtn: true,
            });
            this.props.getChat(res.data.myConversations[0].conversationId);
          } else if (res.data.queueConversations.length > 0) {
            this.setState({
              activeChat: res.data.queueConversations[0].conversationId,
              isVisibleTicketBtn: true,
            });
            this.props.getChat(res.data.queueConversations[0].conversationId);
          } else if (res.data.botConversations.length > 0) {
            this.setState({
              activeChat: res.data.botConversations[0].conversationId,
              isVisibleTicketBtn: true,
            });
            this.props.getChat(res.data.botConversations[0].conversationId);
          }
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }

    if (
      this.props.location !== undefined &&
      this.props.location.state !== undefined &&
      this.props.location.state.incomingchatId != undefined &&
      (prevProps.location.state === undefined ||
        this.props.location.state.incomingchatId !==
        prevProps.location.state.incomingchatId)
    ) {
      // console.log(
      //   'NEW  this.props.incomingchatId',
      //   this.props.location.state.incomingchatId
      // );
      this.acceptChat(this.props.location.state.incomingchatId);
    }
  }

  componentDidMount() {
    const { serviceProvider, fetchServiceRequest } = this.props;

    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
    // try {
    //   var docElm = document.documentElement;
    //   if (docElm.requestFullscreen) {
    //     docElm.requestFullscreen();
    //   } else if (docElm.mozRequestFullScreen) {
    //     docElm.mozRequestFullScreen();
    //   } else if (docElm.webkitRequestFullScreen) {
    //     docElm.webkitRequestFullScreen();
    //   } else if (docElm.msRequestFullscreen) {
    //     docElm.msRequestFullscreen();
    //   }
    //   if (document.getElementById('app-container') !== undefined) {
    //     document.getElementById('app-container').classList.add("main-hidden");
    //     document.getElementById('app-container').classList.add("sub-hidden");
    //     console.log(document.getElementById('app-container'));
    //   }
    // } catch (err) {
    //   console.log('eroror', err);
    // }
    this.props.getPropertyList();
    moment.tz.setDefault(this.props.timeZone);
    this.setState({ isLoading: true });
    // let { offset, items } = this.state;
    // const start = this.minAgos();
    // const end = this.nowTime();

    // AxiosAPI({
    //   methhod: 'get',
    //   url: `${gAPI_Conversations_list}?gid=${getGroupID()}&pid=${
    //     this.props.propertyId
    //   }&df=${start}&dt=${end}&tags=-1&offset=${offset}&limit=${items}&country=-1&facebookSenderName=&channel=All
    //   }&status=Opened&googleSenderName=`,
    // }).then(
    //   (res) => {
    //     this.setState((state) => ({
    //       data: res.data.conversations,
    //       items: res.data.pageSize,
    //       offset: res.data.pageCount,
    //       isLoading: false,
    //     }));
    //     let { data } = this.state;
    //     if (data.length > 0) {
    //       this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
    //       this.props.getChat(data[0].conversationId);
    //     }
    //   },
    //   (error) => {
    //     this.setState({ loading: false, error, isLoading: false });
    //   }
    // );
    var identityBody = {
      identity: getUserID(),
    };
    fetch(TWILIO_TOKEN_GEN_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(identityBody),
    }).then((tokenResponse) => {
      tokenResponse.json().then((twilioToken) => {
        this.setState(
          { accessToken: twilioToken.accessToken },
          this.initConversations
        );
      });
    });

    // console.log('this.props.signalRConnection', this.props.signalRConnection);
    if (
      this.props.signalRConnection !== undefined &&
      this.props.signalRConnection.isAgent !== undefined
    ) {
      this.setState({ agentAccess: this.props.signalRConnection.isAgent });
    }

    if (this.props.signalRConnection.newConnection !== undefined) {
      this.props.signalRConnection.newConnection.connection.on(
        'newChatUserMessage',
        this.newChatMessage
      );
    }
    if (this.props.signalRConnection.newConnection !== undefined) {
      this.props.signalRConnection.newConnection.connection.on(
        'newChat',
        this.newChat
      );
    }
    // const protocol = new signalR.JsonHubProtocol();

    // // // Axios({
    // // //   method: 'post',
    // // //   url: 'http://localhost:7071/api/negotiate',
    // // //   headers: { 'x-ms-signalr-userid': this.props.propertyId },
    // // // }).then((resp) => {
    // this.setState(
    //   {
    //     connection: new signalR.HubConnectionBuilder()
    //       //Url of the azure function app
    //       .withUrl(`${process.env.REACT_APP_SIGNALR}/api`)
    //       .withHubProtocol(protocol)
    //       //.configureLogging(signalR.LogLevel.Trace)
    //       .build(),
    //   },
    //   () => {
    //     // opens the connection.

    //     this.state.connection
    //       .start()
    //       .then((con) => {
    //         console.log(this.state.connection);
    //         console.log('Connection established');

    //         // var a = { propertyId: this.props.propertyId };
    //         console.log(con);
    //         // this.state.connection.send('AddToGroup', {
    //         //   PopertyId: this.props.propertyId,
    //         //   UserId: getUserID(),
    //         // });
    //         // Axios({
    //         //   method: 'post',
    //         //   url: `http://localhost:7071/api/AddToGroup?userId=${getUserID()}&propertyId=${
    //         //     this.props.propertyId
    //         //   }`,
    //         // }).then((resp) => {});
    //         //this.state.connection.invoke('AddToGroup', this.props.propertyId);
    //       })
    //       .catch((err) => console.error(err, 'red'));

    //     // activates the drawing from the server.
    //     this.state.connection.on('newChatMessage', (message) => {
    //       console.log('newChatMessage', message);
    //     });
    //     this.state.connection.on('newChatUserMessage', (message) => {
    //       console.log('newChatUserMessage', message);
    //       console.log('this.state.selectedChat', this.state.selectedChat);
    //       if (
    //         this.state.selectedChat !== undefined &&
    //         message.ConversationId === this.state.selectedChat.conversationId
    //       ) {
    //         // console.log('type', message.Content.type);
    //         // console.log('content', message.Content.messages[0]);
    //         var m = {
    //           sender: message.Source == 'Visitor' ? true : false,
    //           source: message.Source,
    //           text: message.Content.messages[0],
    //           time: moment(message.TimeUtc),
    //           type: message.Content.type,
    //         };
    //         console.log(m);
    //         this.myChatRef.current.loadNewMessage(m);
    //       }
    //     });
    //     this.state.connection.on('newAgentChat', (message) => {
    //       console.log('newAgentChat', message);
    //       this.setState({
    //         chatInvitations: [message, ...this.state.chatInvitations],
    //       });
    //     });
    //     this.state.connection.on('newChat', (message) => {
    //       console.log('newChat', message);
    //       const checkConversations = this.state.data.filter(
    //         (m) => m.conversationId === message
    //       );
    //       if (checkConversations.length === 0) {
    //         AxiosAPI({
    //           methhod: 'get',
    //           url: `${gAPI_Conversations_By_Id}/${message}/conversation?gid=${getGroupID()}`,
    //         }).then(
    //           (res) => {
    //             //this.setState((state) => ({
    //             console.log(res.data);
    //             const newIndex = this.state.activeIndex + 1;
    //             //}));
    //             this.setState({
    //               data: [res.data, ...this.state.data],
    //               activeIndex: newIndex,
    //             });
    //             if (newIndex === 0) {
    //               this.props.getChat(res.data.conversationId);
    //             }
    //             this.audio.play();
    //           },
    //           (error) => {
    //             this.setState({ loading: false, error, isLoading: false });
    //           }
    //         );
    //       }
    //     });
    //     this.state.connection.on('newMessage', this.newMessage);
    //     this.state.connection.on('newConnection', this.newConnection);
    //     this.state.connection.on('disConnection', this.disConnection);
    //     // this.state.connection.onconnect((message) => {
    //     //   console.log('connected', message);
    //     //   Axios({
    //     //     method: 'get',
    //     //     url: `http://localhost:7071/api/AddToGroup?userId=${getUserID()}&propertyId=${
    //     //       this.props.propertyId
    //     //     }`,
    //     //   }).then((resp) => {
    //     //     console.log('Addgroup', resp.data);
    //     //   });
    //     // });
    //   }
    // );
    // // });

    // const connection = new HubConnectionBuilder()
    //   .withUrl('https://bmbcosmotest.azurewebsites.net/api')
    //   .withAutomaticReconnect()
    //   .build();

    // if (connection) {
    //   connection
    //     .start()
    //     .then((result) => {
    //       console.log('Connected Signal R!');
    //       console.log(connection);
    //       connection.on('updateSales', (message) => {
    //         console.log('message', message);
    //       });
    //     })
    //     .catch((e) => console.log('Connection failed: ', e));
    // }
    this.loadQuickTemmplates();
  }

  handleMaskClick = () => {
    if (sessionStorage.getItem('lock') === 'true') {
      sessionStorage.setItem('lock', 'false');
      this.setState({ isMasked: 'false' });
    } else {
      sessionStorage.setItem('lock', 'true');
      this.setState({ isMasked: 'true' });
    }
  };
  // newMessage = (message) => {
  //   console.log('Message', message);
  // };
  // newConnection = (message) => {
  //   console.log('Message', message);
  //   //  data.myConnectionId = message.ConnectionId;
  //   // Axios({
  //   //   method: 'post',
  //   //   url: `http://localhost:7071/api/AddToGroup`,
  //   //   body: {
  //   //     connectionId: message.ConnectionId,
  //   //     recipient: getUserID(),
  //   //     groupname: this.props.propertyId,
  //   //   },
  //   // }).then((resp) => {});
  //   Axios({
  //     method: 'post',
  //     url: `${process.env.REACT_APP_SIGNALR}/api/AddToGroup`,
  //     data: {
  //       connectionId: message,
  //       recipient: getUserID(),
  //       groupname: this.props.propertyId,
  //     },
  //   }).then((resp) => {});
  // };

  // disConnection = (message) => {
  //   console.log('Message', message);
  //   //  data.myConnectionId = message.ConnectionId;
  //   // Axios({
  //   //   method: 'post',
  //   //   url: `http://localhost:7071/api/AddToGroup`,
  //   //   body: {
  //   //     connectionId: message.ConnectionId,
  //   //     recipient: getUserID(),
  //   //     groupname: this.props.propertyId,
  //   //   },
  //   // }).then((resp) => {});
  //   Axios({
  //     method: 'post',
  //     url: `${process.env.REACT_APP_SIGNALR}/api/RemoveFromGroup`,
  //     data: {
  //       connectionId: message,
  //       recipient: getUserID(),
  //       groupname: this.props.propertyId,
  //     },
  //   }).then((resp) => {});
  // };

  initConversations = async () => {
    window.conversationsClient = ConversationsClient;
    this.conversationsClient = await ConversationsClient.create(
      this.state.accessToken
    );
    this.conversationsClient.on('connectionStateChanged', (state) => {
      console.log(state);
    });

    this.conversationsClient.on('conversationJoined', (conversation) => {
      const newConversations = [
        ...this.state.twilioConversations,
        conversation,
      ];
      this.setState({ twilioConversations: newConversations });
      if (
        this.props.chatListApp.selectedchat !== undefined &&
        this.props.chatListApp.selectedchat !== null
      ) {
        if (
          this.props.chatListApp.selectedchat.twilioChatId === conversation.sid
        ) {
          this.setState({ forceRefresh: true });
        }
      }
    });
    this.conversationsClient.on('conversationLeft', (thisConversation) => {
      //console.log(thisConversation);
      // console.log('left');
      this.setState({
        twilioConversations: [
          ...this.state.twilioConversations.filter(
            (it) => it !== thisConversation
          ),
        ],
      });
    });
    if (
      this.props.location !== undefined &&
      this.props.location.state !== undefined
    ) {
      // console.log(
      //   'this.props.incomingchatId',
      //   this.props.location.state.incomingchatId
      // );
      this.acceptChat(this.props.location.state.incomingchatId);
    }
  };

  setTwilioChat = () => {
    let intervalId = setInterval(this.checkTwilioChatReady, 1000);
    this.setState({ intervalId: intervalId });
  };

  checkTwilioChatReady = () => {
    if (this.state.newTwilioChatId !== '') {
      const c = this.state.twilioConversations.filter(
        (m) => m.sid === this.state.newTwilioChatId
      );

      if (c.length > 0) {
        this.setState({ twilioChatId: c[0].sid, twilioLoaded: true });
        clearInterval(this.state.intervalId);
      }
    }
  };

  setBlankTwilioId = () => {
    this.setState({ twilioChatId: '' });
  };

  newChatMessage = (message) => {
    //  console.log('newChatUserMessage', message);
    // console.log('this.state.selectedChat', this.state.selectedChat);
    const checkConversations = this.state.agentConversations.filter(
      (m) => m.conversationId === message.ConversationId
    );
    if (
      this.state.selectedChat !== undefined &&
      message.ConversationId === this.state.selectedChat.conversationId &&
      checkConversations.length == 0 &&
      message.AgentId !== getUserID()
    ) {
      // console.log('type', message.Content.type);
      // console.log('content', message.Content.messages[0]);
      var m = {
        sender: message.Source == 'Visitor' ? true : false,
        source: message.Source,
        text: message.Content.messages[0],
        time: moment(message.TimeUtc),
        type: message.Content.type,
      };
      //console.log(m);
      try {
        this.myChatRef.current.loadNewMessage(m);
      } catch (ex) { }
    }

    if (message.Source == 'Visitor') {
      var agentindex = this.state.agentConversations.findIndex(
        (a) => a.conversationId === message.ConversationId
      );
      // console.log('AgentIdex', agentindex);
      if (agentindex > -1) {
        const values = [...this.state.agentConversations];
        values[agentindex].visitorMessageCount =
          values[agentindex].visitorMessageCount + 1;
        this.setState({
          agentConversations: values,
        });
      } else {
        var queueindex = this.state.waitingConversations.findIndex(
          (a) => a.conversationId === message.ConversationId
        );
        // console.log('queueindex', queueindex);
        if (queueindex > -1) {
          const values = [...this.state.waitingConversations];
          values[queueindex].visitorMessageCount =
            values[queueindex].visitorMessageCount + 1;
          this.setState({
            waitingConversations: values,
          });
        } else {
          var chatindex = this.state.chatBotConversations.findIndex(
            (a) => a.conversationId === message.ConversationId
          );
          // console.log('chatindex', chatindex);
          if (chatindex > -1) {
            const values = [...this.state.chatBotConversations];
            values[chatindex].visitorMessageCount =
              values[chatindex].visitorMessageCount + 1;
            this.setState({
              chatBotConversations: values,
            });
          }
        }
      }
    }

    if (
      message.AgentId === getUserID() &&
      message.Source == 'Visitor' &&
      this.state.selectedChat !== undefined &&
      message.ConversationId !== this.state.selectedChat.conversationId
    ) {
      var agentindex = this.state.agentConversations.findIndex(
        (a) => a.conversationId === message.ConversationId
      );
      // console.log('AgentIdex', agentindex);
      if (agentindex > -1) {
        const values = [...this.state.agentConversations];
        values[agentindex].newMessage = true;
        this.setState({
          agentConversations: values,
        });
      }
    }
  };

  newChat = (message) => {
    //console.log('newChat', message);
    const checkConversations = this.state.chatBotConversations.filter(
      (m) => m.conversationId === message
    );
    const agentConversations = this.state.agentConversations.filter(
      (m) => m.conversationId === message
    );
    if (checkConversations.length === 0 && agentConversations.length === 0) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Conversations_By_Id}/${message}/conversation?gid=${getGroupID()}`,
      }).then(
        (res) => {
          //this.setState((state) => ({
          //console.log(res.data);
          //const newIndex = this.state.activeIndex + 1;
          //}));
          this.setState({
            chatBotConversations: [
              res.data,
              ...this.state.chatBotConversations,
            ],
            // activeIndex: newIndex,
          });
          // if (newIndex === 0) {
          //   this.props.getChat(res.data.conversationId);
          // }
          this.audio.play();
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }
  };

  componentWillReceiveProps(props) {
    if (
      props.chatListApp.selectedchat !== this.props.chatListApp.selectedchat
    ) {
      this.setState({
        selectedChat: props.chatListApp.selectedchat,
        cstatus: props.chatListApp.selectedchat.status,
        twilioChatId: props.chatListApp.selectedchat.twilioChatId,
      });
      if (
        props.chatListApp.selectedchat.visitor &&
        props.chatListApp.selectedchat.visitor.contactId
      ) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_TicketsRecording_id}?contactid=${props.chatListApp.selectedchat.visitor.contactId}`,
        }).then(
          (urlres) => {
            this.setState({
              recordingurl: urlres.data.url,
              //selectedChat: res.data,
              transcript: urlres.data.transcript,
            });
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        this.setState({
          recordingurl: '',
          // selectedChat: res.data,
          transcript: '',
        });
      }
    }
    // console.log('props.signalRConnectio', props.signalRConnection);
    if (
      props.signalRConnection !== undefined &&
      props.signalRConnection.newConnection !== undefined &&
      this.props.signalRConnection.newConnection === undefined
    ) {
      props.signalRConnection.newConnection.connection.on(
        'newChatUserMessage',
        this.newChatMessage
      );
      props.signalRConnection.newConnection.connection.on(
        'newChat',
        this.newChat
      );
    }

    if (
      props.signalRConnection !== undefined &&
      props.signalRConnection.isAgent !== undefined
    ) {
      this.setState({ agentAccess: props.signalRConnection.isAgent });
    }
  }

  handleChangeSelect = (value, { name }) => {
    this.setState({
      [name]: value,
    });
  };
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  loadQuickTemmplates = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_QuickReplies}?groupId=${getGroupID()}&propertyId=${this.props.propertyId
        }&locale=${this.props.locale}`,
    }).then(
      (res) => {
        this.setState((state) => ({
          quickReplyTemplates: res.data,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );

    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_QuickReplies_listByGroup}?groupId=${getGroupID()}&propertyId=&locale=${this.props.locale
        }`,
    }).then(
      (res) => {
        this.setState((state) => ({
          chatReplyTemplates: res.data,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  minAgos = () => {
    return moment(moment().subtract(3600, 'seconds'))
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  nowTime = () => {
    return moment().utc().format('YYYY-MM-DD HH:mm:ss');
  };

  handleContactClick = (index, conversationId) => {
    this.setState({ activeChat: conversationId, isVisibleTicketBtn: true });
    this.stopBlink();
    const chat = this.props.getChat(conversationId);
    var agentindex = this.state.agentConversations.findIndex(
      (a) => a.conversationId === conversationId
    );
    //console.log('AgentIdex', agentindex);
    if (agentindex > -1) {
      const values = [...this.state.agentConversations];
      values[agentindex].newMessage = false;
      this.setState({
        agentConversations: values,
      });
    }
  };

  statustoggle = () => {
    this.setState((prevState) => ({
      statusmodal: !prevState.statusmodal,
    }));
  };

  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  toggleMessanger = () => {
    this.setState((prevState) => ({
      transfertomesseger: !prevState.transfertomesseger,
    }));
  };

  togglebot = () => {
    this.setState((prevState) => ({
      transfertobot: !prevState.transfertobot,
    }));
  };

  toggleTwillioConversation = () => {
    this.setState({
      showTwilioConversationList: !this.state.showTwilioConversationList,
    });
  };

  closeTwilioConversation = (sid, conversationId, channel) => {
    // if (event.target.tagName == 'svg') {
    fetch(
      `${channel === 'WebsiteDirectLine'
        ? TWILIO_END_CONVERSATION
        : TWILIO_END_CHANNELCONVERSATION
      }`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          twilioConversationId: sid,
          channel: channel,
          message: `Agent ${this.props.user && this.props.user.profile.name
            } has left the conversation`,
        }),
      }
    ).then((res) => {
      console.log('Closed');
    });
    AxiosAPI({
      method: 'put',
      url: `${putAPI_UpdateChatStatus_By_Id}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        userId: getUserID(),
        status: 'Ended',
      },
    });

    AxiosAPI({
      method: 'put',
      url: `${putAPI_ConversationsTwilioStart}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        twilioChatId: '',
      },
    }).then((d) => { });
    this.setState({ twilioChatId: '' });

    // var array = [...this.state.agentConversations]; // make a separate copy of the array
    // var index = array.findIndex((a) => a.conversationId === conversationId);
    // // console.log(index);
    // if (index !== -1) {
    //   array.splice(index, 1);
    //   this.setState({ agentConversations: array });
    // }
    // }
  };

  StopFacebookChat = (botConversationId) => {
    // console.log(botConversationId);
    AxiosPublicAPI({
      method: 'get',
      url: `${STOPFB_URL}/${botConversationId}`,
    }).then((userData) => {
      // console.log('stop FB');
      this.toggleMessanger();
      AxiosAPI({
        method: 'put',
        url: `${putAPI_ConversationsFacebookTransfer}/${this.state.selectedChat.conversationId}`,
        data: {
          groupId: getGroupID(),
          transfer: true,
        },
      }).then((d) => { });
    });
  };

  ResumeFacebookChat = (botConversationId) => {
    AxiosPublicAPI({
      method: 'get',
      url: `${RESUMEFB_URL}/${botConversationId}`,
    }).then((userData) => {
      //console.log('resume FB');
      this.togglebot();
      AxiosAPI({
        method: 'put',
        url: `${putAPI_ConversationsFacebookTransfer}/${this.state.selectedChat.conversationId}`,
        data: {
          groupId: getGroupID(),
          transfer: false,
        },
      }).then((d) => { });
    });
  };

  handleTicketSubmit = () => {
    const { ticketComments, ticketType, popupProperty, selectedChat } =
      this.state;
    let tickets = [];
    ticketType && ticketType.map((ticket) => tickets.push(ticket.value));

    const data = {
      notes: ticketComments,
      tags: tickets,
      creator: 'Dashboard',
      Source: 'BobDashboard',
      conversationId: selectedChat.botConversationId,
      propertyId: popupProperty && popupProperty.value,
      groupId: selectedChat.groupId,
    };

    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_Ticket}`,
      data,
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          this.setState({ msg: res.data.Messages });
          this.setState({ open: true });
        } else this.toggle();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  handleStatusSubmit = () => {
    const id = this.state.selectedChat.conversationId;
    AxiosAPI({
      method: 'put',
      url: `${putAPI_ConversationsStatus_By_Id}/${this.state.selectedChat.conversationId}`,
      data: {
        groupId: this.state.selectedChat.groupId,
        status: this.state.cstatus,
      },
    }).then(
      (res) => {
        if (this.state.filterstatus !== 'All') {
          const newList = this.state.data.filter(
            (item) => item.conversationId !== id
          );
          this.setState({ data: newList });
        } else {
          this.props.getChat(id);
        }
        this.statustoggle();
      },
      (error) => { }
    );
  };

  acceptChat = (id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Conversations_By_Id}/${id}?gid=${getGroupID()}`,
    }).then(
      (res) => {
        //console.log(res.data);
        if (res.data.handedOffToAgent === false) {
          this.twilioConnectionToUserChat(
            res.data.botConversationId,
            res.data.visitor.location,
            res.data.visitor.ipAddress,
            id,
            res.data.channel
          );
        }
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  // twilioMakingConnection = (
  //   botConversationId,
  //   location,
  //   ipAddress,
  //   botCoversationMessages
  // ) => {
  //   this.setState({ twilioLoaded: false });
  //   AxiosAPI({
  //     method: 'get',
  //     url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
  //   }).then((userData) => {
  //     let requestBody = {
  //       conversationId: botConversationId,
  //       bmbUser: getUserID(),
  //       location: location,
  //       ipAddress: ipAddress,
  //       welcomeMessage: `Agent ${userData.data.fullName} has joined`,
  //     };
  //     //console.log("botConversationId", botConversationId)

  //     AxiosPublicAPI({
  //       method: 'post',
  //       url: `${
  //         channel === 'WebsiteDirectLine' ? TWILIO_URL : TWILIOCHANNEL_URL
  //       }`,
  //       data: requestBody,
  //     }).then(
  //       (res) => {
  //         if (res.data.twilioConversationId !== undefined) {
  //           AxiosAPI({
  //             method: 'put',
  //             url: `${putAPI_ConversationsTwilioStart}/${this.state.selectedChat.conversationId}`,
  //             data: {
  //               groupId: getGroupID(),
  //               twilioChatId: res.data.twilioConversationId,
  //             },
  //           }).then((d) => {});
  //           this.setState({ newTwilioChatId: res.data.twilioConversationId });
  //           this.setTwilioChat();
  //           //this.twilioStartChat();
  //         }
  //       },
  //       (error) => {
  //         this.setState({ twilioLoaded: true });
  //         console.log(error);
  //       }
  //     );
  //   });
  // };

  twilioConnectionToUserChat = (
    botConversationId,
    location,
    ipAddress,
    conversationId,
    channel
  ) => {
    this.setState({ twilioLoaded: false });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((userData) => {
      let requestBody = {
        conversationId: botConversationId,
        bmbUser: getUserID(),
        location: location,
        ipAddress: ipAddress,
        welcomeMessage: `Agent ${userData.data.fullName} has joined`,
        channel: channel,
      };
      //console.log("botConversationId", botConversationId)
      AxiosPublicAPI({
        method: 'post',
        url: `${channel === 'WebsiteDirectLine' ? TWILIO_URL : TWILIOCHANNEL_URL
          }`,
        data: requestBody,
      }).then(
        (res) => {
          if (res.data.twilioConversationId !== undefined) {
            AxiosAPI({
              method: 'put',
              url: `${putAPI_ConversationsTwilioStart}/${conversationId}`,
              data: {
                groupId: getGroupID(),
                twilioChatId: res.data.twilioConversationId,
              },
            }).then((d) => { });
            this.setState({ newTwilioChatId: res.data.twilioConversationId });
            this.setTwilioChat();
            //this.twilioStartChat();
          }
        },
        (error) => {
          this.setState({ twilioLoaded: true });
          console.log(error);
        }
      );
    });

    AxiosAPI({
      method: 'put',
      url: `${putAPI_UpdateAgentStatus_By_Id}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        userId: getUserID(),
        status: 'Accepted',
      },
    }).then(() => {
      //console.log('Accepted');
      const checkConversations = this.state.chatBotConversations.filter(
        (m) => m.conversationId === conversationId
      );
      if (checkConversations.length === 0) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Conversations_By_Id}/${conversationId}/conversation?gid=${getGroupID()}`,
        }).then(
          (res) => {
            //this.setState((state) => ({
            //console.log(res.data);
            //const newIndex = this.state.activeIndex + 1;
            //}));
            this.setState({
              agentConversations: [res.data, ...this.state.agentConversations],
              activeChat: res.data.conversationId,
            });
            //if (newIndex === 0) {
            this.props.getChat(res.data.conversationId);
            //}
            this.audio.play();
          },
          (error) => {
            this.setState({ loading: false, error, isLoading: false });
          }
        );
      } else {
        this.setState({
          agentConversations: [
            checkConversations[0],
            ...this.state.agentConversations,
          ],
          activeChat: checkConversations[0].conversationId,
        });
        this.props.getChat(checkConversations[0].conversationId);
        var array = [...this.state.chatBotConversations]; // make a separate copy of the array
        // console.log(
        //   'this.state.chatBotConversations',
        //   this.state.chatBotConversations
        // );

        var index = array.findIndex((a) => a.conversationId === conversationId);
        //console.log(index);
        if (index !== -1) {
          array.splice(index, 1);
          //console.log('array', array);
          this.setState({ chatBotConversations: array });
        }
      }
    });
  };

  stopBlink = () => {
    this.props.BotBlink(false);
    this.props.AgentBlink(false);
  };

  TransferBotToMessanger = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={this.state.transfertomesseger}
                keyboard="false"
                backdrop="static"
                toggle={this.toggleMessanger}
              >
                <ModalHeader>Handover to Messenger</ModalHeader>
                <ModalBody>
                  <p>
                    {' '}
                    Chatbot will stop responding to the user messages, and you
                    will need to respond from the Facebook Messenger app. You
                    can anytime give control back to the chatbot for this
                    Facebook user.{' '}
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={this.toggleMessanger}>
                    Continue
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  TransferToBot = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={this.state.transfertobot}
                keyboard="false"
                backdrop="static"
                toggle={this.togglebot}
              >
                <ModalHeader>Handover to Chatbot</ModalHeader>
                <ModalBody>
                  <p>
                    {' '}
                    Chatbot will start responding to this user messages. You can
                    anytime take control back from the chatbot for this Facebook
                    user.
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={this.togglebot}>
                    Continue
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  render() {
    const {
      usersListApp: { properties },
      signalRConnection,
      user,
      featuresUrl,
    } = this.props;
    const {
      selectedChat,
      startDate,
      endDate,
      modal,
      ticketType,
      ticketPriority,
      popupProperty,
      isVisibleTicketBtn,
    } = this.state;

    const imageDomain =
      featuresUrl && !featuresUrl.includes('myma.ai')
        ? `https://assets.${featuresUrl}`
        : 'https://assets.bookmebob.com';

    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Modal isOpen={modal} toggle={this.toggle} size="lg">
              <ModalHeader toggle={this.toggle}>
                <IntlMessages id="Ticket Details" />
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Colxx xxs="12">
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Ticket Type" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          isMulti={true}
                          className="react-select"
                          classNamePrefix="react-select"
                          name="ticketType"
                          value={ticketType}
                          onChange={this.handleChangeSelect}
                          options={TicketTypeOptions}
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Property" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          name="popupProperty"
                          value={properties && popupProperty}
                          onChange={this.handleChangeSelect}
                          options={
                            properties
                              ? reactSelectOption(properties, false)
                              : []
                          }
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Comments" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Input
                          name="ticketComments"
                          onChange={this.handleInputChange}
                          type="textarea"
                          placeholdertext="Comments"
                        />
                      </Colxx>
                    </Row>
                    <Row>
                      <Colxx xxs="3">
                        <Button
                          color="primary"
                          className="mb-2"
                          onClick={this.handleTicketSubmit}
                        >
                          <IntlMessages id="forms.submit" />
                        </Button>
                      </Colxx>
                    </Row>
                  </Colxx>
                </Row>
              </ModalBody>
            </Modal>
          </Colxx>
        </Row>
        {this.state.twilioLoaded &&
          (this.state.chatBotConversations.length > 0 ||
            this.state.agentConversations.length > 0 ||
            this.state.waitingConversations.length > 0) &&
          this.state.agentAccess === true && (
            <Row>
              <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4">
                <Conversations
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  offset={this.state.offset}
                  items={this.state.items}
                  isLoading={this.state.isLoading}
                  data={this.state.data}
                  activeIndex={this.state.activeIndex}
                  pid={this.props.propertyId}
                  handleContactClick={this.handleContactClick}
                  agentConversations={this.state.agentConversations}
                  waitingConversations={this.state.waitingConversations}
                  chatBotConversations={this.state.chatBotConversations}
                  activeChat={this.state.activeChat}
                  handleMaskClick={this.handleMaskClick}
                  isMasked={this.state.isMasked}
                  properties={this.props.properties}
                  imageDomain={imageDomain}
                />
              </Colxx>
              <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4">
                <Chat
                  chat={selectedChat}
                  accessToken={this.state.accessToken}
                  twilioConversations={this.state.twilioConversations}
                  twilioChatId={this.state.twilioChatId}
                  forceRefresh={this.state.forceRefresh}
                  closeTwilioConversation={this.closeTwilioConversation}
                  ref={this.myChatRef}
                  profileName={user && user.profile.name}
                  stopBlink={this.stopBlink}
                  chatReplyTemplates={this.state.chatReplyTemplates}
                  setBlankTwilioId={this.setBlankTwilioId}
                  twilioConnectionToUserChat={this.twilioConnectionToUserChat}
                />
              </Colxx>
              <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4">
                {/* <Card
                  className="cardHeightActive"
                  style={{ overflow: 'scroll' }}
                >
                  <CardBody> */}
                {selectedChat && selectedChat.visitor != null && (
                  <Visitor
                    item={selectedChat}
                    twilioConnectionToUserChat={this.twilioConnectionToUserChat}
                    StopFacebookChat={this.StopFacebookChat}
                    ResumeFacebookChat={this.ResumeFacebookChat}
                    toggle={this.toggle}
                    clickedLinks={
                      selectedChat.clickedLinks !== undefined
                        ? selectedChat.clickedLinks
                        : undefined
                    }
                    recordingurl={this.state.recordingurl}
                    transcript={this.state.transcript}
                    quickReplyTemplates={this.state.quickReplyTemplates}
                    propertyId={this.props.propertyId}
                    loadQuickTemmplates={this.loadQuickTemmplates}
                    statustoggle={this.statustoggle}
                    twilioChatId={this.state.twilioChatId}
                    handleMaskClick={this.handleMaskClick}
                    isMasked={this.state.isMasked}
                  />
                )}
                {/* </CardBody>
                </Card> */}
              </Colxx>
            </Row>
          )}

        {!this.state.twilioLoaded && (
          <Fragment>
            <div className="loading"></div>
            <div
              style={{
                textAlign: 'center',
                fontSize: '16px',
                margin: '8px 0',
              }}
            >
              <IntlMessages id='dashboard.hang_in_there' />
            </div>
          </Fragment>
        )}
        {this.state.chatBotConversations.length === 0 &&
          this.state.waitingConversations.length === 0 &&
          this.state.agentConversations.length === 0 &&
          this.state.isLoading === false &&
          this.state.agentAccess === true && (
            <Fragment>
              <div
                style={{
                  position: 'absolute',
                  left: '40%',
                  top: '30%',
                }}
              >
                {/* No active chats at the moment */}
                <img
                  src={noactivechats}
                  alt="No Active Conversations"
                  style={{ maxWidth: '400px' }}
                />
              </div>
            </Fragment>
          )}
        {this.state.agentAccess === false && (
          <Fragment>
            <div
              style={{
                position: 'absolute',
                left: '40%',
                top: '30%',
              }}
            >
              {/* No active chats at the moment */}
              <img
                src={`${imageDomain}/images/noagentrole.png`}
                alt="No Active Conversations"
                style={{ maxWidth: '400px' }}
              />
            </div>
          </Fragment>
        )}
        {this.TransferBotToMessanger()}
        {this.TransferToBot()}
        {/* {this.state.chatInvitations.length > 0 && (
          <Fragment>
            <div className="ongoing">
              <ul style={{ float: 'right' }}>
                {this.state.chatInvitations.map((person, i) => (
                  <div className="msg_box" style={{ right: `${270 * i}px` }}>
                    <div className="msg_head">
                      <div
                        className="chatclose"
                        onClick={() => this.rejectChat(person)}
                      >
                        x
                      </div>
                    </div>
                    <div className="msg_wrap">
                      <div className="msg_body">
                        <p>
                          User requested to chat with the agent. Please click
                          accept to connect to conversation or click cancel to
                          close the request{' '}
                        </p>
                        <p>
                          <Button
                            color="primary"
                            outline
                            size="xs"
                            onClick={() => this.acceptChat(person)}
                            style={{ borderRadius: '6px' }}
                          >
                            Accept
                          </Button>{' '}
                          <Button
                            color="secondary"
                            outline
                            size="xs"
                            onClick={() => this.rejectChat(person)}
                            style={{ borderRadius: '6px' }}
                          >
                            Cancel
                          </Button>{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
          </Fragment>
        )} */}
        <Row>
          <Colxx xxs="12">
            <Modal isOpen={this.state.statusmodal} toggle={this.statustoggle}>
              <ModalHeader toggle={this.statustoggle}>
                Change Conversation Status
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Colxx xxs="12">
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Status" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Input
                          type="select"
                          value={this.state.cstatus}
                          name="cstatus"
                          onChange={this.handleInputChange}
                        >
                          <option value="Opened">New</option>
                          <option value="Closed">Closed</option>
                        </Input>
                      </Colxx>
                    </Row>
                    <Row>
                      <Colxx xxs="3">
                        <Button
                          color="primary"
                          className="mb-2"
                          onClick={this.handleStatusSubmit}
                        >
                          Save
                        </Button>
                      </Colxx>
                    </Row>
                  </Colxx>
                </Row>
              </ModalBody>
            </Modal>
          </Colxx>
        </Row>
        <Validation
          open={this.state.open}
          messages={this.state.msg}
          toggle={() => {
            this.setState({ open: false });
          }}
        ></Validation>
      </Fragment>
    );
  }
}
const mapStateToProps = ({
  chatListApp,
  usersListApp,
  settings,
  signalRConnection,
  oidc,
  service,
}) => {
  const { propertyId, timeZone, locale, email, serviceProvider } = settings;
  const { properties } = usersListApp;
  const { featuresUrl } = service;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    email,
    signalRConnection,
    properties,
    user: oidc.user,
    serviceProvider,
    featuresUrl,
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    getChatList,
    getChatListSearch,
    getChat,
    getPropertyList,
    createTicket,
    BotBlink,
    AgentBlink,
    fetchServiceRequest,
  })(OngoingConversationsPage)
);
